import * as React from "react";

import Image from "../../elements/Image/Image";
import {Headings} from "../../elements/Headings/Headings";
import './Logo.scss';

const Logo = ({ title, logos, use_greyscale }) => {
    return (
        <div className="featured-companies">
            <div className="featured-companies__container">
                <div className={'featured-companies__title'}>
                    <Headings text={title} type={'h2'}/>
                </div>

                <div className={`featured-companies__list ${ use_greyscale && 'grayscale-[100]' }`}>
                    {logos.map((logo, index) => (
                        <div key={logo.key || index} className={`featured-companies__item`}>
                            <a href={logo.settings.url}><Image imageUrl={logo.settings.logo} /></a>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Logo;
